import {
    HIDE_REQUEST_CONFIRMATION_MODAL,
    RESET_AVAILABLE_QTY, SHOW_REQUEST_CONFIRMATION_MODAL, TOGGLE_CREATE_REQUEST_BUTTON_CLICK,
    UPDATE_AVAILABLE_QTY, UPDATE_BASIC_DETAILS_LOWER_SECTION_VALIDATION_CHECK,
    UPDATE_LOCATION_SECTION_FIELDS,
    UPDATE_LOWER_SECTION_FIELDS,
    UPDATE_UPPER_SECTION_FIELDS
} from "../types/singleCreateRequestTypes";
import {
    BasicDetailsLowerSectionState,
    BasicDetailsUpperSectionState,
    LocationDetailsFields
} from "../../../interfaces/creationFlowInterfaces";
import { SingleCreateRequestActions } from "../actions/singleCreateRequestActions";

const basicDetailsUpperSectionState: BasicDetailsUpperSectionState = {
    selectedSource: "",
    selectedDest: "",
    selectedProjectTag: {},
    selectedIPN: "",
};

const basicDetailsLowerSectionState: BasicDetailsLowerSectionState = {
    selectedPriority: {},
    selectedQty: "",
    selectedDate: "",
};

const locationDetailsState: LocationDetailsFields = {
    selectedDeliveryOrReferenceId: "",
};

const initialState = {
    basicDetailsUpperSectionState: basicDetailsUpperSectionState,
    basicDetailsLowerSectionState: basicDetailsLowerSectionState,
    locationDetailsState: locationDetailsState,
    availableQty: "",
    showRequestConfirmationModal: false,
    isCreateRequestButtonClicked: false,
    basicDetailsLowerSectionValidationCheck: false
};

const singleCreateRequestReducer = (
    state = initialState,
    action: SingleCreateRequestActions
) => {
    switch (action.type) {
        case UPDATE_UPPER_SECTION_FIELDS:
            return {
                ...state,
                basicDetailsUpperSectionState: {
                    ...state.basicDetailsUpperSectionState,
                    ...action.payload,
                },
            };
        case UPDATE_LOWER_SECTION_FIELDS:
            return {
                ...state,
                basicDetailsLowerSectionState: {
                    ...state.basicDetailsLowerSectionState,
                    ...action.payload,
                },
            };
        case UPDATE_LOCATION_SECTION_FIELDS:
            return {
                ...state,
                locationDetailsState: {
                    ...state.locationDetailsState,
                    ...action.payload,
                },
            };
        case UPDATE_AVAILABLE_QTY:
            return {
                ...state,
                availableQty: action.payload
            }
        case RESET_AVAILABLE_QTY:
            return {
                ...state,
                availableQty: ""
            }
        case SHOW_REQUEST_CONFIRMATION_MODAL:
            return {
                ...state,
                showRequestConfirmationModal: true
            }
        case HIDE_REQUEST_CONFIRMATION_MODAL:
            return {
                ...state,
                showRequestConfirmationModal: false
            }
        case TOGGLE_CREATE_REQUEST_BUTTON_CLICK:
            return {
                ...state,
                isCreateRequestButtonClicked: action.payload
            }
        case UPDATE_BASIC_DETAILS_LOWER_SECTION_VALIDATION_CHECK:
            return {
                ...state,
                basicDetailsLowerSectionValidationCheck: action.payload
            }
        default:
            return state;
    }
};

export default singleCreateRequestReducer;